import React, { useState, useEffect } from 'react';
import useReactRouter from 'use-react-router';

import KartePanel from '../panels/KartePanel';
import ProcessingContainer from "../../containers/Processing";

const Root = (() => {

  const processingContainer = ProcessingContainer.useContainer();
  const [isLoading, setIsLoading] = useState(false);
  const { location } = useReactRouter();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await processingContainer.loadQRData(location.search.substr(1));
      setIsLoading(false);
    })();
  }, []);

  return (
    <KartePanel isLoading={isLoading} karte={processingContainer.kartes.find(karte => true)} />
  )
}) as React.FC;

export default (() => {
  return (
    <ProcessingContainer.Provider>
      <Root />
    </ProcessingContainer.Provider>
  )
}) as React.FC;
